import { render, staticRenderFns } from "./VideoViewer.vue?vue&type=template&id=081a7670&"
import script from "./VideoViewer.vue?vue&type=script&lang=js&"
export * from "./VideoViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports